import axios from "./request";
import { API_PATH } from "../utils/config";

export const getUserProfileById = (user_id) => {
  return axios.get(API_PATH.GET_USER_PROFILE_BY_ID(user_id));
};

export const getUserWheels = (user_id, query) => {
  return axios.get(API_PATH.GET_USER_WHEELS_BY_ID(user_id, query));
};

export const getUserWheelsV2 = (query) => {
  return axios.get(API_PATH.GET_USER_WHEELS_BY_ID_V2(query));
};

export const fetchWheels = async ({ pageParam = 1 }) => {
  const response = await axios.get("/api/v2/wheel/", {
    params: {
      page: pageParam, // Current page to fetch
      page_size: 20, // Number of results per page
      user_id: 8,
    },
  });
  return response.data;
};

export const getBgWallpapers = () => {
  return axios.get(API_PATH.GET_BG_WALLPAPERS);
};

export const getPrimaryWheel = (userId) => {
  return axios.get(API_PATH.GET_PRIMARY_WHEEL);
};

export const createUserWheel = (data) => {
  return axios.post(API_PATH.CREATE_WHEEL, data);
};

export const getAiWheel = (temp_id) => {
  return axios.get(API_PATH.GET_LATEST_AI_WHEEL(temp_id));
};

export const generateAiWheel = (data) => {
  return axios.post(API_PATH.GENERATE_AI_WHEEL, data);
};

export const getMyCustomColors = () => {
  return axios.get(API_PATH.GET_MY_CUSTOM_COLORS());
};

export const addMyCustomColor = (data) => {
  return axios.post(API_PATH.ADD_MY_CUSTOM_COLORS(), data);
};

export const editMyCustomColor = (id, data) => {
  return axios.patch(API_PATH.EDIT_MY_CUSTOM_COLORS(id), data);
};

export const deleteMyCustomColor = (id) => {
  return axios.delete(API_PATH.EDIT_MY_CUSTOM_COLORS(id));
};
export const duplicateWheel = (data) => {
  return axios.post(API_PATH.CLONE_WHEEL(data.WheelID), data.data);
};
export const search = (text) => {
  return axios.get(API_PATH.GENERAL_SEARCH(text));
};

export const searchUsers = (search, page = 1, page_size = 10) => {
  return axios.get(API_PATH.SEARCH_USERS(search, page, page_size));
};

export const searchWheels = (search, page = 1, page_size = 10) => {
  return axios.get(API_PATH.SEARCH_WHEELS(search, page, page_size));
};

export const cloneWheel = (id, data) => {
  return axios.post(API_PATH.CLONE_WHEEL(id), data);
};

export const cloneSegment = (id) => {
  return axios.post(API_PATH.CLONE_SEGMENT(id));
};

export const likeUnlikeWheel = (id) => {
  return axios.post(API_PATH.LIKE_UNLIKE_WHEEL(id));
};

export const getAllTransactions = (
  startDate,
  endDate,
  limit = 10,
  offset = 0
) => {
  return axios.get(
    API_PATH.GET_ALL_TRANSACTIONS(startDate, endDate, limit, offset)
  );
};

export const getAllCards = () => {
  return axios.get(API_PATH.LIST_ALL_CARDS);
};

export const removeCard = (id) => {
  return axios.post(API_PATH.DELETE_CARD(id));
};

export const getCurrentPlan = () => {
  return axios.get(API_PATH.GET_ACTIVE_SUBSCRIPTION);
};

export const canCreateWheel = () => {
  return axios.get(API_PATH.CAN_CREATE_WHEEL);
};

export const canCloneWheel = () => {
  return axios.get(API_PATH.CAN_CLONE_WHEEL);
};

export const getSubscriptionComparison = (data) => {
  return axios.get(API_PATH.COMPARE_SUBSCRIPTION, { params: data });
};

export const downloadInvoice = (data) => {
  return axios.post(API_PATH.DOWNLOAD_INVOICE, data);
};

// Referrals

export const getAmbassadorReferral = (queryParams) => {
  const { sub_filter, ...otherParams } = queryParams;

  // Build query string manually for sub_filter to avoid array notation
  let queryString = "";
  const searchParams = new URLSearchParams();

  // Add other parameters
  Object.entries(otherParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  });

  // Add sub_filter parameters individually
  if (sub_filter && Array.isArray(sub_filter)) {
    sub_filter.forEach((filter) => {
      searchParams.append("sub_filter", filter);
    });
  }

  queryString = searchParams.toString();
  const url = queryString
    ? `${API_PATH.REFERRAL_AMBASSADOR}?${queryString}`
    : API_PATH.REFERRAL_AMBASSADOR;

  return axios.get(url);
};

export const getBtReferral = (queryParams) => {
  const { sub_filter, ...otherParams } = queryParams;

  // Build query string manually for sub_filter to avoid array notation
  let queryString = "";
  const searchParams = new URLSearchParams();

  // Add other parameters
  Object.entries(otherParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  });

  // Add sub_filter parameters individually
  if (sub_filter && Array.isArray(sub_filter)) {
    sub_filter.forEach((filter) => {
      searchParams.append("sub_filter", filter);
    });
  }

  queryString = searchParams.toString();
  const url = queryString
    ? `${API_PATH.REFERRAL_BT}?${queryString}`
    : API_PATH.REFERRAL_BT;

  return axios.get(url);
};

export const getDirectReferral = (queryParams) => {
  const { sub_filter, ...otherParams } = queryParams;

  // Build query string manually for sub_filter to avoid array notation
  let queryString = "";
  const searchParams = new URLSearchParams();

  // Add other parameters
  Object.entries(otherParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  });

  // Add sub_filter parameters individually
  if (sub_filter && Array.isArray(sub_filter)) {
    sub_filter.forEach((filter) => {
      searchParams.append("sub_filter", filter);
    });
  }

  queryString = searchParams.toString();
  const url = queryString
    ? `${API_PATH.REFERRAL_DIRECT}?${queryString}`
    : API_PATH.REFERRAL_DIRECT;

  return axios.get(url);
};

export const getAnalytics = (queryParams) => {
  const params = {
    ...queryParams,
    limit: 10,
  };
  return axios.get(API_PATH.ANALYTICS, { params });
};

export const sendReferralInvites = (data) => {
  return axios.post(API_PATH.REFERRAL_INVITES_API(), data);
};

export const getBalance = () => {
  return axios.get(API_PATH.GET_BALANCE);
};

export const getTokenBundles = () => {
  return axios.get(API_PATH.GET_TOKEN_BUNDLES);
};

export const purchaseTokenBundle = (data) => {
  return axios.post(API_PATH.PURCHASE_TOKEN_BUNDLE, data);
};

export const connectStripeAccount = (data) => {
  return axios.post(API_PATH.CONNECT_STRIPE_API(), data);
};

export const getStripeAccountStatus = () => {
  return axios.get(API_PATH.GET_STRIPE_ACCOUNT_STATUS);
};

export const getReferralsChart = (category, time) => {
  return axios.get(API_PATH.REFERRAL_CHART(category, time));
};

export const downloadReferralsReport = (query) => {
  return axios.get(API_PATH.DOWNLOAD_REFERRALS_REPORT(query));
};

export const getHallOfFame = (query, startDate, endDate) => {
  return axios.get(API_PATH.GET_HALL_OF_FAME(query, startDate, endDate));
};

export const getAnalyticsDetail = (queryParams) => {
  const params = {
    ...queryParams,
    limit: 10,
  };
  return axios.get(API_PATH.GET_ANALYTICS_DETAIL, { params });
};

export const getWheelEmailPermission = (id) => {
  return axios.get(API_PATH.GET_WHEEL_EMAIL_PERMISSION(id));
};

export const deleteWheelEmailPermission = (id, data) => {
  return axios.post(API_PATH.DELETE_WHEEL_EMAIL_PERMISSION(id), data);
};

export const uploadImage = (data) => {
  return axios.put(API_PATH.UPLOAD_IMAGE, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getPrimaryWheelV2 = (id) => {
  return axios.get(API_PATH.GET_PRIMARY_WHEEL_V2(id));
};

export const getQueriedUserWheels = (user_id, query) => {
  return axios.get(API_PATH.GET_USER_WHEELS(user_id, query));
};

export const signupBeta = (data) => {
  return axios.post(API_PATH.SIGNUP_BETA_V2(), data);
};

export const avifToPng = (file) => {
  const formData = new FormData();
  formData.append("avif_file", file);

  return axios.post(API_PATH.AVIF_T0_PNG, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Fetch Palette Library
export const getPaletteLibrary = (wheelId, type, search, usageType) => {
  return axios.get(
    API_PATH.GET_PALETTE_LIBRARY(wheelId, type, search, usageType)
  );
};

// Delete a Palette
export const deletePalette = (paletteId) => {
  return axios.delete(API_PATH.DELETE_PALETTE(), {
    data: { id: paletteId }, // Send ID in the request body
  });
};

// Generate a Scheme
export const generateScheme = (data) => {
  return axios.post(API_PATH.GENERATE_SCHEME(), data);
};

// Save a Palette
export const savePalette = (paletteData) => {
  return axios.post(API_PATH.SAVE_PALETTE(), paletteData);
};

// Generate Colors from Image
export const generateColorsFromImage = (imageUrl, count = 5) => {
  return axios.post(API_PATH.GENERATE_COLORS_FROM_IMAGE(), {
    image_url: imageUrl,
    count,
  });
};

export const generateColorsFromPrompt = (data) => {
  return axios.post(API_PATH.GENERATE_COLORS_FROM_PROMPT(), data);
};

export const saveRecentMedia = (wheelId, mediaData) => {
  return axios.post(API_PATH.SAVE_RECENT_MEDIA(wheelId), {
    wheel: wheelId,
    ...mediaData,
  });
};

export const saveExternalImage = (data) => {
  return axios.post(API_PATH.SAVE_EXTERNAL_IMAGE(), data);
};

// Get Recent Media
export const getRecentMedia = (wheelId, type, page) => {
  return axios.get(API_PATH.GET_RECENT_MEDIA(wheelId, type, page));
};

// Get total storage
export const getTotalStorage = () => {
  return axios.get(API_PATH.GET_TOTAL_STORAGE());
};

// Get all storage
export const getTotalMedia = () => {
  return axios.get(API_PATH.GET_TOTAL_MEDIA());
};

// Delete selected media
export const deleteMediaFiles = (paths) => {
  return axios.post(API_PATH.DELETE_MEDIA(), {
    wheel_ids: paths, // Send paths in request body
  });
};

//delete all media
export const deleteAllMedia = () => {
  return axios.post(API_PATH.DELETE_ALL_MEDIA());
};

//get media by type
export const getMediaByCategory = (type, pageToken) => {
  return axios.get(API_PATH.GET_MEDIA_BY_CATEGORY(type, pageToken));
};
export const getContentModerationListing = (status, search, pageToken) => {
  return axios.get(
    API_PATH.GET_CONTENT_MODERATION_LISTING(status, search, pageToken)
  );
};

export const getWheelMedia = (id) => {
  return axios.get(API_PATH.GET_WHEEL_MEDIA(id));
};

export const getWheelDetails = async (wheelId, queryParams = "") => {
  try {
    return await axios.get(
      `${API_PATH.GET_WHEEL_DETIALS(wheelId)}${queryParams}`
    );
  } catch (err) {
    throw err;
  }
};
//get notifications
export const getNotifications = (page) => {
  return axios.get(API_PATH.GET_NOTIFICATIONS(page));
};

//mark as reak
export const markAllRead = () => {
  return axios.post(API_PATH.MARK_ALL_READ());
};

export const checkIfUserEligible = (feature) => {
  return axios.post(API_PATH.CHECK_PERMISSIONS, { feature });
};

export const updateWheelPreview = async (wheelId) => {
  const response = await axios.put(
    API_PATH.TAKE_SCREENSHOT_OF_WHEEL(wheelId),
    {}
  );
  return response.data;
};

export const getCommissionStructure = () => {
  return axios.get(API_PATH.GET_COMMISSION_STRUCTURE);
};

export const getCommissionEvaluation = () => {
  return axios.get(API_PATH.GET_COMMISSION_EVALUATION);
};

export const sendWheelMedia = (wheelId, mediaData) => {
  return axios.post(API_PATH.SEND_WHEEL_MEDIA(wheelId), {
    wheel_id: wheelId,
    urls: mediaData,
  });
};

export const deleteWheelMedia = (data) => {
  return axios.post(API_PATH.DELETE_WHEEL_MEDIA(), data);
};

export const postMediaModeration = (data) => {
  return axios.post(API_PATH.POST_MEDIA_MODERATION(), data);
};

export const getProfileByReferCode = (code) => {
  return axios.get(API_PATH.GET_PROFILE_BY_REFER_CODE(code));
};

export const getLatestWheelToShowInReferModal = (id) => {
  return axios.get(API_PATH.GET_LATEST_WHEEL_TO_SHOW_IN_REFER_MODAL(id));
};

export const postWheelScreenshot = (wheelId, data) => {
  return axios.post(API_PATH.POST_SCREENSHOT(wheelId), data);
};

export const getSegmentDetails = (segmentId) => {
  return axios.get(API_PATH.GET_SEGMENT_DETAILS(segmentId));
};

export const checkReferral = (data) => {
  return axios.post(API_PATH.CHECK_REFERRAL(), data);
};

export const phoneLookup = (data) => {
  return axios.post(API_PATH.PHONE_LOOKUP, data);
};

export const renameColorPalette = (data) => {
  return axios.post(API_PATH.RENAME_COLOR_PALETTE, data);
};

export const getWheelCount = () => {
  return axios.get(API_PATH.GET_WHEEL_COUNT);
};

export const generateAICompletion = (data) => {
  return axios.post(API_PATH.GENERATE_AI_COMPLETION, data);
};

export const generateAISuggestions = (data) => {
  return axios.post(API_PATH.GENERATE_AI_SUGGESTIONS, data);
};

export const generateAITitles = (prompt, count = 1) => {
  const params = new URLSearchParams({
    prompt: prompt,
    count: count.toString(),
  });
  return axios.get(`${API_PATH.GENERATE_AI_TITLES}?${params}`);
};
